module.exports = __webpack_public_path__ + "static/media/lithuania-flag.aabaf50c.png";